import React, { useEffect, useState } from "react";

import { makeStyles, TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { fetchAvailableCities } from "../../../services/locationApi";

const useStyles = makeStyles(theme => ({
  TextField: {
    width: "100%",
    margin: theme.spacing(1)
  },
  autocompleteDropdownContainer: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    paddingLeft: "10px",
    paddingRight: "10px"
  }
}));

const PlacesInput = ({ value, onChange, onSelect }) => {
  const classes = useStyles();
  const [availableCities, setAvailableCities] = useState([]);

  useEffect(() => {
    fetchAvailableCities().then(response => setAvailableCities(response.data))
  }, []);

  return <Autocomplete
    label="Address"
    options={availableCities}
    getOptionLabel={(o) => o}
    onChange={(e, newValue) => onChange(newValue)}
    value={value}
    renderInput={(params) => (<TextField
      autoComplete="off"
      label="Address"
      fullWidth
      placeholder={"Search Places ..."}
      className={classes.TextField}
      {...params}
    />)
    }
  />
};

export default PlacesInput;
